var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { request } from "../request";
import { API_V1_PATH } from "../config";
export const getDocuments = ({ parentId = null, } = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const searchParams = new URLSearchParams();
    if (parentId !== null) {
        searchParams.set("parentId", String(parentId));
    }
    const query = searchParams.toString();
    return request(`${API_V1_PATH}/document${query ? `?${query}` : ""}`, {
        method: "GET",
    });
});
